var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_402",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_402",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACW0lEQVR4nO3cu27UQBSH8RMRLTRIWwdEBQV0pOERAg200FFRcSlp6RIegQop8AKh4glIaAgVDRUINiWXSChSEB9ysNASnKx313NmPPP/lSvvxZ8s20ezspmIiIiIjAFOAY+BEbADrFWvjW8jcwKWgC3+9wY4N+/nix1Evgx84GifgSuKNd+RfBP4wWR7wG3FnhJwoj4HT+sJsDjt9xUJOA1sMLuXwDD2fiQNOA+8Y37vgYux9ydJwArwhe58B67H3q+kAHeAfbr3E3hopePPELJOeOuThhtgMDYQHb59rC7MA+vxEPIaP9V3LR3zeybd5axZhkNIKKOjhpuGI/mwHesT4FbLISSUxuGmzRst8yEklH+GmzZvsJ4MIS9Iz9/hps3GljLgQkdDSCgHw02bDS1VwDXgK+lrNShZioAH9cCQDUsJcBJ4SoasByshWbAUAMvARzJmsSUwhLiIGTi1ISSoWJGH9Q1/SYbekVMfQkION5e8Il/teCWkb6qVmxuhI2c3hMzoF/AIWOg6cLX68HzWX5WxZ52uvACrsfcoYatdhq7WzaTZSKF9fOoydDFDSexTx6COrVNIjL8hUBiLhcKYQvtQaCcK7UShnSh0gxAXdoVuoNBOFNqJQjtRaCcK7UShnSi0E4V2otBOFNqJQjtRaCcK7UShnSi0E4V2otBOFNqJQjtRaCcK7UShnSh0j+l/HU4UuoDQu5TjW8zQng8IjG0zZuj7lONu7Mf6vCV/29GfTQqczTz2NnDGUlAf2feq81gmF8hd4FV1uoh+JIuIiIiIiIiIWHp+AyQbWTgpWw5yAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.2adf2c1870bf3b501532fcae785c228f.svg";
export { ForwardRef as ReactComponent };